var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var UserActionModalController = /** @class */ (function (_super) {
            __extends(UserActionModalController, _super);
            function UserActionModalController($scope, userActionDto, model, process, userActionInfoUniqueId, documentConfiguration, systemDocumentConfiguration, userActionService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.userActionDto = userActionDto;
                _this.scope.model = model;
                _this.scope.process = process;
                _this.scope.userActionInfoUniqueId = userActionInfoUniqueId;
                _this.scope.documentConfiguration = documentConfiguration;
                _this.scope.systemDocumentConfiguration = systemDocumentConfiguration;
                _this.scope.userActionService = userActionService;
                _this.scope.canSave = function () { return _this.getValidationMessages(_this.scope).length === 0; };
                _this.scope.getValidationMessages = function () { return _this.getValidationMessages(_this.scope); };
                _this.scope.documentUpdated = function (model) { return _this.documentUpdated(model); };
                _this.scope.resetEffectiveDate = function () {
                    _this.scope.model.effectiveDate = undefined;
                };
                //Randy - transient user action data preservation for validation error
                var transientUserActionDto = userActionService.getTransientUserActionData(userActionDto.id);
                if (transientUserActionDto != null) {
                    _this.scope.model.processActionWorkflowBlockId = transientUserActionDto.processActionWorkflowBlockId;
                    _this.scope.model.effectiveDate = transientUserActionDto.effectiveDate;
                    _this.scope.model.comment = transientUserActionDto.comment;
                    _this.scope.model.docIds = transientUserActionDto.docIds;
                    _this.scope.model.showEffectiveDate = transientUserActionDto.effectiveDate != null && transientUserActionDto.effectiveDate != undefined;
                    if (transientUserActionDto.documents != null) {
                        for (var i = 0; i < transientUserActionDto.documents.length; i++) {
                            _this.scope.process.documents.push(transientUserActionDto.documents[i]);
                        }
                    }
                }
                return _this;
                //Randy - end transient user action data preservation for validation error
            }
            UserActionModalController.prototype.getValidationMessages = function (scope) {
                var results = [];
                if (scope.userActionDto.commentRequired && !scope.model.comment)
                    results.push("A comment is required.");
                if (scope.userActionDto.attachmentRequired && scope.model.docIds.length === 0)
                    results.push("An attachment is required.");
                return results;
            };
            UserActionModalController.prototype.documentUpdated = function (model) {
                this.scope.model.docIds = Enumerable.from(model.documents).select(function (i) { return i.id; }).toArray();
                //Randy - transient user action data preservation for validation error
                this.scope.userActionService.updateDocuments(model.documents);
                //Randy - end transient user action data preservation for validation error
            };
            return UserActionModalController;
        }(controllers.BaseModalController));
        controllers.UserActionModalController = UserActionModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('UserActionModalController', ["$scope", "userActionDto", "model", "process", "userActionInfoUniqueId", "documentConfiguration", "systemDocumentConfiguration", "userActionService", "close"]);
